const getInitialState = () => {}

export const simpleReducer = (state = getInitialState(), message) => {
    // test for initialState calls
    if (!message) {
        return state
    }

    if (message.baseline && message.type !== 'event') {
        return state
    }

    switch (message.type) {
        case 'start':
            return getInitialState()

        case 'event':
            return {
                value: message.events[0].fieldA + message.events[0].fieldB
            }
        default:
            return state
    }
}
